import { Routes, Route, Navigate, useParams } from "react-router-dom";
import MainRoutes from "@routes/MainRoutes";
import AuthRoutes from "@routes/AuthRoutes";
import AuthGuard from "@routes/guards/AuthGuard";
import PublicGuard from "@routes/guards/PublicGuard";

// Component to handle forgot password redirect with proper parameter substitution
const ForgotRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/auth/forgot/${id}`} replace />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Root redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Public Routes - grouped under /auth */}
      <Route
        path="/auth/*"
        element={
          <PublicGuard>
            <AuthRoutes />
          </PublicGuard>
        }
      />

      {/* Auth Routes - everything else is protected */}
      <Route
        path="/*"
        element={
          <AuthGuard>
            <MainRoutes />
          </AuthGuard>
        }
      />

      {/* Backward compatibility redirects */}
      <Route path="/login" element={<Navigate to="/auth/login" replace />} />
      <Route path="/signup" element={<Navigate to="/auth/signup" replace />} />
      <Route path="/register" element={<Navigate to="/auth/signup" replace />} />
      <Route path="/forgot/:id" element={<ForgotRedirect />} />
    </Routes>
  );
};

export default AppRoutes;
